{
  "id": "campaign-117",
  "name": "Fine Promenade",
  "seed": "campaign:117",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ".......ACCA......x",
    "..%%....CC....%%..",
    "x.%..t.tCCt.t.,%,.",
    "........CC.....,..",
    ".T.B..t.CC.t..B.T.",
    ".......CCCC.......",
    ".......CwwC.......",
    ".......CwwC.......",
    "...Y...CwwC...Y...",
    ".......CCCC.......",
    "........CC........",
    "www+wwww++wwww+www",
    "....****CC****.,..",
    "..B.....CC,~..,B..",
    "........CC~,...,..",
    "........CC....,,,.",
    "...x.........x.,..",
    "S....x.....x......"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 1,
      "y": 10
    },
    {
      "kind": "rabbit",
      "x": 14,
      "y": 17
    },
    {
      "kind": "rabbit",
      "x": 6,
      "y": 3
    },
    {
      "kind": "squirrel",
      "x": 0,
      "y": 7
    },
    {
      "kind": "squirrel",
      "x": 14,
      "y": 7
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 9,
      "y": 11
    },
    {
      "kind": "gas",
      "x": 14,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 16,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 13
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "generatorVersion": 3,
  "level": 117,
  "biome": "estate",
  "par": {
    "reel": 9610,
    "push": 8524,
    "selfPropelled": 7647,
    "tractor": 6193,
    "zeroTurn": 5265,
    "fairway": 3871
  },
  "goldTime": {
    "reel": 9186,
    "push": 8079,
    "selfPropelled": 7587,
    "tractor": 6193,
    "zeroTurn": 5095,
    "fairway": 3767
  },
  "routeTries": {
    "par": {
      "reel": 20,
      "push": 5,
      "selfPropelled": 4,
      "tractor": 24,
      "zeroTurn": 9,
      "fairway": 8
    },
    "gold": {
      "reel": 38,
      "push": 37,
      "selfPropelled": 37,
      "tractor": 24,
      "zeroTurn": 28,
      "fairway": 31
    }
  }
}
